import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Step from './Step.js';

/**
 *
 */
export default class Timeline extends withBreakpointObserver(Base) {
  static config = {
    name: 'Timeline',
    components: {
      Step,
    },
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };
}
